import { configureStore } from "@reduxjs/toolkit";
import adminStoreReducer from "store/slices/adminStoreSlice";
import authReducer from "store/slices/authSlice";
import categoryReducer from "store/slices/categorySlice";
import marketReducer from "store/slices/marketSlice";
import masterProductsReducer from "store/slices/masterProductsSlice";
import packagesReducer from "store/slices/packagesSlice";
import repsReducer from "store/slices/repsSlice";
import vendorsReducer from "store/slices/vendorsSlice";

export const store = configureStore({
  reducer: {
    adminStores: adminStoreReducer,
    auth: authReducer,
    categories: categoryReducer,
    markets: marketReducer,
    masterProducts: masterProductsReducer,
    packages: packagesReducer,
    reps: repsReducer,
    vendors: vendorsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
